<template>
    <div class="component-settings-playground">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card mt-20" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never" v-loading="!loaded">
                        <div class="row">
                            <div class="col-12">
                                <el-button :disabled="!canEdit()" class="fr ml-10" type="primary" @click="addRegression" @submit.prevent="submit" icon="el-icon-plus">New regression</el-button>
                            </div>
                        </div>
                        <el-tabs @tab-click="tabClicked" v-model="activeName" v-if="regressions.length > 0">
                            <el-tab-pane v-for="reg of regressions" :key="reg.set_id" :label="reg.settings.name" :name="String(reg.set_id)">
                                <template>
                                    <div class="row center-align-vert">
                                        <div class="col-12">
                                            <el-button class="fr ml-10" type="primary" @click="save" :disabled="!canEdit()" :loading="saving" @submit.prevent="submit" icon="el-icon-upload">Save</el-button>
                                        </div>
                                    </div>
                                    <el-alert
                                        title="Playground settings saved"
                                        type="success"
                                        show-icon
                                        v-show="saveSuccess"
                                        style="max-width: 80%; margin: 10px auto;">
                                    </el-alert>
                                    <div class="row center-align-vert">
                                        <div class="col-12">
                                            <el-form :inline="true" class="fl mt-10">
                                                <el-form-item label="Set name">
                                                    <el-input :disabled="!canEdit()" style="max-width: 150px" placeholder="Name" v-model="reg.settings.name"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Target">
                                                    <el-slider
                                                        style="width: 150px;"
                                                        :format-tooltip="formatTooltipSlider"
                                                        v-model="reg.settings.target"
                                                        :disabled="!canEdit()"
                                                        :step=0.01
                                                        :min=0.5
                                                        :max=1.5>
                                                    </el-slider>
                                                </el-form-item>
                                                <el-form-item label="Weeks amount">
                                                    <el-select :disabled="!canEdit()" style="width: 75px;" v-model="reg.settings.weeks_data" placeholder="Weeks amount">
                                                        <el-option
                                                            label="26"
                                                            value=26>
                                                        </el-option>
                                                        <el-option
                                                            label="52"
                                                            value=52>
                                                        </el-option>
                                                        <el-option
                                                            label="104"
                                                            value=104>
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="Filter managers" v-if="loaded">
                                                    <el-select
                                                        v-model="managers"
                                                        filterable
                                                        :clearable=true
                                                        multiple
                                                        collapse-tags
                                                        placeholder="Filter managers"
                                                        @visible-change="managerSelectChange($event)"
                                                        @change="checkManagerSelect($event)"
                                                        v-if="$route.name.includes('magazine') === false">
                                                        <el-option
                                                            label="All managers"
                                                            value="all">
                                                        </el-option>
                                                        <el-option
                                                            v-for="item in $store.getters['general/getStoreInterests']"
                                                            :key="item.user_id"
                                                            :label="item.user_name"
                                                            :value="item.user_id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="Stores">
                                                    <el-select
                                                        v-model="reg.settings.store_id"
                                                        filterable
                                                        :clearable=true
                                                        :disabled="!canEdit()"
                                                        multiple
                                                        collapse-tags
                                                        placeholder="Stores"
                                                        style="width: 225px;"
                                                        @visible-change="storeSelectChange($event)">
                                                        <el-option
                                                            v-for="item in $store.getters['general/getStores']"
                                                            :key="item.store_id"
                                                            :label="item.store_name.substring(0,15)"
                                                            :value="item.store_id">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="Set id">
                                                    <el-input  style="max-width: 50px" placeholder="Set id" v-model="reg.set_id" disabled></el-input>
                                                </el-form-item>
                                                <el-form-item label="Version">
                                                    <el-input style="max-width: 50px" placeholder="Version" v-model="reg.version" disabled></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                    <div class="row" style='margin-top: 20px;'>
                                        <div class="col-12">
                                            <p class="bold">Variables</p>
                                            <el-table
                                                :data="reg.settings.variables"
                                                style="width: 100%; margin-bottom: 20px;"
                                            >
                                                <el-table-column
                                                    :key="String(reg.set_id) + 'var'"
                                                    prop="var"
                                                    label="Variable"
                                                >
                                                    <template slot-scope="scope">
                                                        {{scope.row.var | formatVariableName}}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    :key="String(reg.set_id) + 'transform'"
                                                    prop="transform"
                                                    label="Transform"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-slider
                                                            style="width: 150px;"
                                                            v-model="scope.row.transform"
                                                            :disabled="!canEdit()"
                                                            :step=0.05
                                                            :min=0.5
                                                            :max=2>
                                                        </el-slider>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    :key="String(reg.set_id) + 'factor'"
                                                    prop="factor"
                                                    label="Factor"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-input @change="checkFactorInput" :disabled="scope.row.percentage_var === true || !canEdit()" style="max-width: 100px" v-model="scope.row.factor"></el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    :key="String(reg.set_id) + 'percentage'"
                                                    prop="percentage"
                                                    label="Percentage"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-slider
                                                            style="width: 150px;"
                                                            v-model="scope.row.percentage"
                                                            :format-tooltip="formatTooltipSlider"
                                                            :disabled="scope.row.percentage_var === false || !canEdit()"
                                                            :step=0.05
                                                            :min=0.0
                                                            :max=1
                                                        >
                                                        </el-slider>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    :key="String(reg.set_id) + 'percentage_var'"
                                                    prop="percentage_var"
                                                    label="Percentage variable"
                                                >
                                                    <template slot-scope="scope">
                                                        <el-switch :disabled="!canEdit()" v-model="scope.row.percentage_var"></el-switch>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="show_in_graph" label="Show in graph">
                                                    <template slot-scope="scope">
                                                        <el-switch :disabled="!canEdit()" @change="changeSwitch(scope.row.var)" :value="(showInGraph === scope.row.var)"></el-switch>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="delete" label="Delete">
                                                    <template slot-scope="scope">
                                                        <el-button :disabled="!canEdit()" type="danger" @click="deleteVariable(scope.row)" @submit.prevent="submit" icon="el-icon-delete"></el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <el-select value="Add variable" placeholder="Add variable" :disabled="!canEdit()" @change="addVariable">
                                                <el-option
                                                    v-for="(item,index) in variableOptions"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                            <el-button class="fr" type="warning" :loading="testing" @click="test()" @submit.prevent="submit">Test settings</el-button>
                                        </div>
                                    </div>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                        <p v-else class="text-center">There are no regressions yet</p>
                    </el-card>
                </div>
            </div>
            <el-card v-show="visDataLoaded" class="box-card text-left mt-50" shadow="never">
                <div class="row" v-if="visDataLoaded">
                    <div class="col-12 mb-10">
                        <h4>Total results</h4>
                    </div>
                    <div class="col-3">
                        <!-- <el-table :data="progressBar.table">
                            <el-table-column label="Realized" prop="realized"></el-table-column>
                            <el-table-column label="Target" prop="target"></el-table-column>
                            <el-table-column label="Correction" prop="correction"></el-table-column>
                            <el-table-column label="Budget total" prop="budget_total"></el-table-column>
                        </el-table> -->
                        <el-card class="box-card" shadow="never">
                            <div slot="header" class="box-content">
                                <p class="title">Realized</p>
                            </div>
                            <div class="box-content text-center">
                                <p>{{progressBar.table.realized}}</p>
                            </div>
                        </el-card>
                    </div>
                    <div class="col-3">
                        <el-card class="box-card" shadow="never">
                            <div slot="header" class="box-content">
                                <p class="title">Target</p>
                            </div>
                            <div class="box-content text-center">
                                <p>{{progressBar.table.target}}</p>
                            </div>
                        </el-card>
                    </div>
                    <div class="col-3">
                        <el-card class="box-card" shadow="never">
                            <div slot="header" class="box-content">
                                <p class="title">Correction</p>
                            </div>
                            <div class="box-content text-center">
                                <p>{{progressBar.table.correction}}</p>
                            </div>
                        </el-card>
                    </div>
                    <div class="col-3">
                        <el-card class="box-card" shadow="never">
                            <div slot="header" class="box-content">
                                <p class="title m-0-auto">Budget total</p>
                            </div>
                            <div class="box-content text-center">
                                <p>{{progressBar.table.budget_total}}</p>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div class="row mb-50 mt-20">
                    <div class="col-12">
                        <b-progress v-if="Object.keys(progressBar).length > 0" class="mt-2" :max="Object.values(progressBar.bar).reduce((a, b) => a + b, 0)" height="37px" show-value>
                            <b-progress-bar v-for="(value,key) of progressBar.bar" :label="getProgressLabel(key)" :value="value" :key="key" :striped=false :style="{'background-color': getColorBar(key)}"></b-progress-bar>
                        </b-progress>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12" v-show="chartsLoaded">
                        <h4>Store results</h4>
                        <box-plot-chart class="mb-50 mt-10" v-if="chartsLoaded" :chart-data="storesChart.data" :options="storesChart.options" />

                        <h4>Week results <span v-if="rowSelected !== null">for store {{rowSelected}}</span></h4>
                        <line-chart v-if="chartsLoaded" :chartData="weeksChart.data" :options="weeksChart.options"></line-chart>

                        <div v-if="tableLoaded" class="mt-50">
                            <div class="row">
                                <div class="col-6">
                                    <h4>Store table</h4>
                                </div>
                                <div class="col-6">
                                    <el-input style="width: 200px; float: right;" v-model="filters[0].value" placeholder="Search store"></el-input>
                                </div>
                            </div>
                            <data-tables :filters="filters" :table-props='tableProps' @row-click="rowClicked" ref="proposalTable" :data="storesTableData" :page-size="10" :pagination-props="{background: true, pageSizes: [10,20,50] }">
                                <el-table-column prop="store_id" label="Store"><template slot-scope="scope">{{$store.getters['general/getStores'].find(x => parseInt(x.store_id) === parseInt(scope.row.store_id)).store_name}}</template></el-table-column>
                                <el-table-column
                                    v-for="col in storesTableCols"
                                    :key="col.key"
                                    :prop="col.prop"
                                    :label="col.label"
                                    :formatter="tableFormatter"
                                    :sortable=true
                                >
                                </el-table-column>
                                <el-table-column prop="dataload" label="More info">
                                    <template slot-scope="scope">
                                        <font-awesome-icon size="1x" icon="info-circle" aria-hidden="true" v-b-popover.hover.right="getDataload(scope.row.store_id)" variant="primary"/>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>

                    </div>
                    <div v-show="!chartsLoaded" class="col-12">
                        <div class="loader-container" >
                            <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
                        </div>
                    </div>
                </div>
            </el-card>
        </el-card>
    </div>
</template>
<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken, colors, formatString } from '../../functions'
import { FacebookLoader } from 'vue-content-loader'
import BoxPlotChart from '@/chart/BoxPlotChart.js'
import LineChart from '@/chart/LineChart.js'

const hexToRgbA = function (hex, opacity) {
    var c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    } else { return hex }
}

export default {
    data () {
        return {
            loaded: false,
            regressions: [],
            activeName: '',
            variableOptions: [],
            testing: false,
            saving: false,
            chartsLoaded: false,
            visDataLoaded: false,
            storesTableData: [],
            storesTableCols: [],
            tableLoaded: false,
            weeksChart: null,
            storesChart: null,
            weeksData: null,
            tableProps: { 'row-class-name': this.tableRowClassName, 'row-key': 'store_id', 'default-expand-all': false, 'summary-method': this.getSummaries, 'show-summary': true, 'tree-props': {} },
            filters: [
                {
                    prop: 'store_id',
                    value: ''
                }
            ],
            rowSelected: null,
            saveSuccess: false,
            showInGraph: '',
            progressBar: {},
            managers: []
        }
    },
    components: {
        FacebookLoader,
        BoxPlotChart,
        LineChart
    },
    computed: {
        percentageLeft () {
            let result = 1
            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
            for (let item of active.settings.variables) {
                if (item.percentage_var === true) {
                    result -= item.percentage
                }
            }
            return result
        }
    },
    methods: {
        redrawComponents () {
            for (let i in this.$refs) {
                this.$refs[i].draw()
            }
            console.log(this.$refs)
        },
        canEdit () {
            let roles = localStorage.getItem('roles').split(',')
            if (roles.includes('0') || roles.includes('1') || roles.includes('2')) {
                return true
            } else {
                return false
            }
        },
        checkFactorInput () {
            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
            for (let item of active.settings.variables) {
                item.factor = String(item.factor).replace(/,/g, '.')
                item.factor = parseFloat(item.factor)
            }
        },
        getProgressLabel (val) {
            return formatString(val) + ' (' + String(this.progressBar.bar[val]) + ')'
        },
        getColorBar (val) {
            let idx = Object.keys(this.progressBar.bar).indexOf(val)
            if (val === 'correction') {
                return colors[3]
            }

            if (idx > 2) {
                idx += 1
            }
            return colors[idx]
        },
        changeSwitch (val) {
            this.showInGraph = val
        },
        checkPercentage () {
            let sum = 0
            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
            for (let item of active.settings.variables) {
                if (item.percentage_var === true) {
                    sum += item.percentage
                }
            }
            if (sum > 1) {
                for (let item of active.settings.variables) {
                    if (item.percentage_var === true) {
                        item.percentage /= sum
                    }
                    item.percentage = parseFloat(item.percentage.toFixed(2))
                }
            }
        },
        getDataload (store) {
            let dataString = ''
            let data = this.storesTableData.find(x => x.store_id === store).dataload
            for (let key in data) {
                let val = formatString(key) + ': ' + data[key].toLocaleString()
                dataString += val + '<br>'
            }
            return {
                html: true,
                content: () => {
                    return dataString
                }
            }
        },
        formatTooltipSlider (val) {
            return String((val * 100).toFixed(0)) + '%'
        },
        tableFormatter (row, column, cellValue, index) {
            if (cellValue !== null) {
                return cellValue.toLocaleString()
            } else {
                return cellValue
            }
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.store_id === this.rowSelected) {
                return 'row-selected'
            }
        },
        tabClicked (tab) {
            this.chartsLoaded = false
            this.visDataLoaded = false
        },
        rowClicked (row) {
            if (this.rowSelected === row.store_id) {
                this.rowSelected = null
                this.plotWeeksChart(this.weeksData[0])
            } else {
                this.rowSelected = row.store_id
                this.plotWeeksChart(this.weeksData[row.store_id])
            }
        },
        addRegression () {
            this.saving = true
            if (this.regressions.length > 0) {
                let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
                axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/regression', active, { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        this.saving = false
                        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/template', { headers: getHeadersWithAccessToken() })
                            .then(response => {
                                let newReg = response.data.data[0]
                                newReg['settings']['name'] = 'New ' + String(newReg['set_id'])
                                newReg['settings']['variables'] = []
                                this.regressions.push(response.data.data[0])
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => console.log(error))
            } else {
                axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/template', { headers: getHeadersWithAccessToken() })
                    .then(response => {
                        let newReg = response.data.data[0]
                        this.activeName = String(response.data.data[0].set_id)
                        newReg['settings']['name'] = 'New ' + String(newReg['set_id'])
                        newReg['settings']['variables'] = []
                        this.regressions.push(response.data.data[0])
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },

        save () {
            this.saving = true
            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))

            for (let item of active.settings.variables) {
                let idx = active.settings.variables.indexOf(item)
                if (Object.keys(item).includes('percentage') === false || item['percentage'] === null || item['percentage'] === undefined || item['percentage'] === 0 || item['percentage'] === '' || item['percentage'] === '0' || item['percentage'] === 'None') {
                    active.settings.variables[idx]['percentage_var'] = false
                    if (Object.keys(item).includes('percentage') === false || item['percentage'] === null || item['percentage'] === undefined || item['percentage'] === '' || item['percentage'] === 'None') {
                        active.settings.variables[idx]['percentage'] = 0
                    }
                } else {
                    active.settings.variables[idx]['percentage_var'] = true
                }
            }

            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/regression', active, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.saving = false
                    this.saveSuccess = true
                    // eslint-disable-next-line
                    setTimeout(() => this.saveSuccess = false, 5000)
                    axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/regression?latest_version=true', { headers: getHeadersWithAccessToken() })
                        .then(response => {
                            this.loaded = true
                            this.regressions = response.data['data']
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => console.log(error))
        },

        addVariable (val) {
            if (val !== undefined && val !== null) {
                let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
                let idx = this.regressions.indexOf(active)
                this.regressions[idx].settings.variables.push({ 'var': val, 'factor': null, 'transform': 1, 'percentage': null, 'percentage_var': false })
            }
        },

        deleteVariable (row) {
            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
            let idx = this.regressions.indexOf(active)
            let reg = this.regressions[idx]
            // Find var based on name, transform of clicked row
            let variable = reg.settings.variables.find(x => (x.var === row.var && x.transform === row.transform))
            let varIdx = reg.settings.variables.indexOf(variable)
            let newVars = reg.settings.variables
            newVars.splice(varIdx, 1)
            vue.set(this.regressions[idx].settings, 'variables', newVars)
        },

        test () {
            this.testing = true
            this.checkPercentage()

            let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))

            for (let item of active.settings.variables) {
                let idx = active.settings.variables.indexOf(item)
                if (Object.keys(item).includes('percentage') === false || item['percentage'] === null || item['percentage'] === undefined || item['percentage'] === 0 || item['percentage'] === '' || item['percentage'] === '0') {
                    active.settings.variables[idx]['percentage_var'] = false
                    if (Object.keys(item).includes('percentage') === false || item['percentage'] === null || item['percentage'] === undefined || item['percentage'] === '') {
                        active.settings.variables[idx]['percentage'] = 0
                    }
                } else {
                    active.settings.variables[idx]['percentage_var'] = true
                }
            }

            let idx = this.regressions.indexOf(active)
            let reg = this.regressions[idx].settings
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/playground', reg, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.visDataLoaded = true
                    vue.set(this.regressions[idx]['settings'], 'variables', response.data['settings']['variables'])
                    this.weeksData = response.data.data.weeks_graph
                    this.plotWeeksChart(this.weeksData[0])
                    this.plotStoresChart(response.data.data.stores_graph)
                    this.showTable(response.data.data.stores_table)
                    this.totalRow = response.data.data.stores_table_total[0]
                    this.progressBar = response.data.data.progress_bar
                    this.chartsLoaded = true
                    this.testing = false
                })
                .catch(error => {
                    console.log(error)
                    this.testing = false
                })
        },
        showTable (data) {
            vue.set(this, 'storesTableData', [])
            vue.set(this, 'storesTableCols', [])

            for (let item of data) {
                // item['child'] = false
                // item['children'] = item['dataload']
                // item['children']['store_id'] = parseInt('100' + String(item['store_id']))
                // item['children']['child'] = true
                // delete item['dataload']
                this.storesTableData.push(item)
            }

            for (let item of Object.keys(data[0])) {
                if (item !== 'dataload' && item !== 'child' && item !== 'children') {
                    this.storesTableCols.push({ 'prop': item, 'label': formatString(item), 'key': item })
                }
            }
            this.tableLoaded = true
        },
        getSummaries (param) {
            let copyTotalRow = this.totalRow
            delete copyTotalRow['dataload']
            let sums = Object.values(copyTotalRow)
            sums.unshift('Total') // Needed for store_nr_name
            for (let idx in sums) {
                if (sums[idx] !== null) {
                    sums[idx] = sums[idx].toLocaleString()
                }
            }
            sums[0] = 'Total'
            sums[1] = ''
            return sums
        },
        plotWeeksChart (data) {
            let budgetcorrected = []
            let real = []
            let minhours = []
            let yearweek = []
            let extraData = {}
            extraData[this.showInGraph] = []

            for (let item of data) {
                budgetcorrected.push(item['budget'])
                real.push(item['hours_real'])
                minhours.push(item['min_hours'])
                yearweek.push(item['yearweek'])
                extraData[this.showInGraph].push(item['dataload'][this.showInGraph])
            }

            yearweek = Array.from(new Set(yearweek))

            let datasets = []
            let obj = {}
            obj.label = 'Hours real'
            obj.data = real
            obj.type = 'line'
            obj.yAxisID = 'A'
            obj.radius = 0
            obj.showLine = true
            obj.fill = false
            obj.backgroundColor = hexToRgbA(colors[1], 0.3)
            obj.borderColor = hexToRgbA(colors[1], 1)
            datasets.push(obj)
            obj = {}
            obj.label = 'Budget'
            obj.data = budgetcorrected
            obj.type = 'line'
            obj.yAxisID = 'A'
            obj.radius = 0
            obj.showLine = true
            obj.fill = false
            obj.backgroundColor = hexToRgbA(colors[0], 0.3)
            obj.borderColor = hexToRgbA(colors[0], 1)
            datasets.push(obj)
            obj = {}
            obj.label = 'Minimum hours'
            obj.data = minhours
            obj.type = 'line'
            obj.yAxisID = 'A'
            obj.radius = 3
            obj.showLine = false
            obj.fill = false
            obj.backgroundColor = hexToRgbA(colors[3], 1)
            obj.borderColor = hexToRgbA(colors[3], 1)
            datasets.push(obj)

            if (this.showInGraph !== '') {
                obj = {}
                obj.label = formatString(this.showInGraph)
                obj.data = extraData[this.showInGraph]
                obj.type = 'line'
                obj.yAxisID = 'B'
                obj.radius = 0
                obj.showLine = true
                obj.fill = true
                obj.backgroundColor = hexToRgbA(colors[4], 0.3)
                obj.borderColor = hexToRgbA(colors[4], 1)
                datasets.push(obj)
            }

            let scales = { 'yAxes': [{ stacked: false, display: true, scaleLabel: { display: true, labelString: 'Hours' }, id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: 'Period' } }

            if (this.showInGraph !== '') {
                scales['yAxes'].push({ stacked: false, display: true, scaleLabel: { display: true, labelString: '' }, id: 'B', position: 'right' })
            }

            this.weeksChart = {
                data: {
                    labels: yearweek,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        xAxes: scales.xAxes,
                        yAxes: scales.yAxes
                    }
                }
            }
        },
        plotStoresChart (data) {
            let storeIds = []
            for (let item of data) {
                storeIds.push(item['store_id'])
            }

            let datasets = []
            let obj = { 'label': [''], 'backgroundColor': [], 'data': [] }
            for (let idx in storeIds) {
                obj.backgroundColor.push(colors[0])
                let boxplotData = []
                for (let item of this.weeksData[storeIds[idx]]) {
                    boxplotData.push(item['budget'])
                }
                obj.data.push(boxplotData)
            }
            datasets.push(obj)

            let labels = []
            for (let item of storeIds) {
                labels.push(this.$store.getters['general/getStores'].find(x => parseInt(x.store_id) === parseInt(item)).store_name)
            }

            let scales = { 'yAxes': [{ stacked: false, display: true, scaleLabel: { display: true, labelString: 'Hours' }, id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: 'Period' } }

            this.storesChart = {
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: scales.xAxes,
                        yAxes: scales.yAxes
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                        }
                    }
                }
            }
        },
        storeSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the graphs
                this.managers = []
            }
        },
        managerSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                let active = this.regressions.find(x => parseInt(x.set_id) === parseInt(this.activeName))
                active.settings.store_id = data
            }
        },
        checkManagerSelect (managers) {
            if (managers.includes('all')) {
                this.managers = this.$store.getters['general/getStoreInterests'].map(s => s.user_id)
            }
        }
    },
    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/regression?latest_version=true', { headers: getHeadersWithAccessToken() })
            .then(response => {
                this.loaded = true
                if (response.data.data.length > 0) {
                    this.regressions = response.data.data
                    this.activeName = String(response.data.data[0].set_id)
                }
            })
            .catch(error => {
                console.log(error)
            })

        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_REGRESSION_API_BASE_URL_DEV : process.env.VUE_APP_REGRESSION_API_BASE_URL) + '/variables', { headers: getHeadersWithAccessToken() })
            .then(response => {
                this.variableOptions = response.data.data
            })
            .catch(error => {
                console.log(error)
            })

        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.loaded = true
            this.managers = []
        })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-playground {
    .el-pagination {
        padding: 1.25rem 5px 0px 5px;
    }
    .sc-table .pagination-wrap {
        text-align: right;
    }
    .el-pagination__jump {
        display: none !important;
    }
    .el-table__expanded-cell {
        padding: 20px 50px !important;
    }
    .el-table th {
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .row-selected {
        background-color: #F5F7FA;
        border-bottom: 1px solid #EBEEF5;
        transition: background-color .25s ease;
        -webkit-transition: background-color .25s ease;
    }
    .box-content {
        display: flex;
        justify-content: center;
        align-items: center;
        p {
            margin-bottom: 0px;
        }
    }
    p.title {
        font-weight: 600;
    }
    p.bold {
        margin-bottom: 0px;
        font-weight: 800;
    }

}
</style>
